import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import Table from '../../components/Table';
import { useSelector } from 'react-redux';
import { IconButton } from '@mui/material';
import { useDependencyInjection } from 'hooks/useDependencyInjection';
import { Icon } from '@iconify/react';
import { HtmlTooltip } from 'components/tooltips/HtmlTootip';
import NumberFormat from 'react-number-format';
import { cleanCpfCnpj } from 'utils';

function Clients() {
  const [clients, setMeaserements] = useState([]);
  const [exportData, setExportData] = useState([]);
  const [openProgress, setOpenProgress] = useState(false);
  const nameProperty = useSelector((state) => state.nameProperty.nameProperty);

  const { history } = useDependencyInjection();

  const columns = [
    {
      title: 'Nome',
      field: 'name',
      hideFilterIcon: true,
    },
    {
      title: 'CPF/CNPJ',
      field: 'cpfCnpj',
      hideFilterIcon: true,
      render: (rowData) => {
        const cpfCnpj = cleanCpfCnpj(rowData?.cpfCnpj);
        return cpfCnpj?.length === 11 ? (
          <NumberFormat
            value={rowData.cpfCnpj}
            displayType="text"
            format="###.###.###-##"
          />
        ) : (
          <NumberFormat
            value={rowData.cpfCnpj}
            displayType="text"
            format="##.###.###/####-##"
          />
        );
      },
    },
    {
      title: 'Endereço',
      field: 'street',
      hideFilterIcon: true,
      render: (rowData) => <p>{`${rowData.street}, ${rowData.number}`}</p>,
    },
    {
      title: 'Cidade/UF',
      field: 'city',
      editable: 'never',
      hideFilterIcon: true,
      render: (rowData) => <p>{`${rowData.city}/${rowData.uf}`}</p>,
    },
    {
      title: 'Ação',
      hideFilterIcon: true,
      render: (rowData) => (
        <HtmlTooltip
          title="Listar vendas"
          placement="right"
          arrow
          interactive
        >
          <IconButton onClick={(e) => {
            e.stopPropagation();
            history.push({
              pathname: `/sales/${rowData.id}`,
              state: {
                name: rowData.name,
                id: rowData.id,
              },
            });
          }}
          >
            <Icon color="#545454" icon="ic:baseline-local-grocery-store" />
          </IconButton>
        </HtmlTooltip>
      ),
    },
  ];

  useEffect(() => {
    async function loadData() {
      try {
        const response = await api.get('/clients');

        if (response.data.length === 0) {
          setOpenProgress(true);
        }
        if (response.data) {
          const data = await response.data;
          const organizedData = await data.map((_element) => ({
            name: _element.name,
            uf: _element.uf,
            city: _element.city,
            street: `Rua: ${_element.street}, N.°: ${_element.number}`,
          }));
          setMeaserements(data);
          setExportData(organizedData);
          setOpenProgress(true);
        }
      } catch (err) {

      }
    }
    loadData();
  }, [nameProperty]);

  function setData(newData) {
    const tempData = [];
    clients.map((client) => (client.id === newData.id ? tempData.push(newData) : tempData.push(client)));
    setMeaserements(tempData);
  }

  return (
    <Table
      title="Clientes"
      route="/clients/"
      routeAdd="/client/"
      columns={columns}
      data={clients}
      setData={setData}
      dataLoaded={openProgress}
      exportData={exportData}
    />
  );
}

export default Clients;
